module.exports = __webpack_public_path__ + "img/banner_about.2ec2eb5e.png";